/**
 * EmailArchePage
 *
 * Route wrapper for the email arche. Wraps all sub-routes in ArcheLayout.
 */

import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { InboxPage } from './InboxPage';
import { SettingsPage } from './SettingsPage';
import { ContactsPage } from './ContactsPage';
import { SearchPage } from './SearchPage';
import { ScreenerPage } from './ScreenerPage';

export function EmailArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/screener" element={<ScreenerPage />} />
        <Route path="/snoozed" element={<InboxPage />} />
        <Route path="/scheduled" element={<InboxPage />} />
        <Route path="/folder/:folderId" element={<InboxPage />} />
        <Route path="/label/:labelId" element={<InboxPage />} />
        <Route path="/*" element={<InboxPage />} />
      </Routes>
    </ArcheLayout>
  );
}
